import {
  PlaneIcon
} from "./chunk-UJYDDCTN.mjs";
export {
  PlaneIcon
};
